var $ = require('jquery');
var extend = require('extend');

function Accordion(config) {
	this.config = extend({}, {
		component: 'accordion',
		trigger: 'accordion__trigger',
		active: 'accordion--active',
		doAutoClose: false
	}, config);
}

Accordion.prototype.activate = function () {
	if (document.querySelector('.' + this.config.component) === null) return;

	this.buildElementList();
	this.attachHandlers();
};

Accordion.prototype.buildElementList = function () {
	this.el = {
		components: document.querySelectorAll('.' + this.config.component),
		triggers: document.querySelectorAll('.' + this.config.trigger)
	}
};

Accordion.prototype.attachHandlers = function () {
	var that = this;

	// Add event listener to each trigger
	for (var i = 0; i < this.el.triggers.length; i++) {
		this.el.triggers[i].addEventListener('click', function(event) {
			event.preventDefault();

			that.toggleAccordion(this);
		});
	}
};

Accordion.prototype.toggleAccordion = function (element) {
	// Get parent element
	var parentAccordion = $(element).closest('.' + this.config.component)[0];

	// Shortcircuit if no parent accordion found
	if (parentAccordion === undefined) return;

	// Test if item has active class
	var isOpen = undefined;
	if (parentAccordion.classList) {
		isOpen = parentAccordion.classList.contains(this.config.active);
	} else {
		isOpen = new RegExp('(^| )' + this.config.active + '( |$)', 'gi').test(parentAccordion);
	}

	// Open or close
	if (!isOpen) {
		this.openAccordion(parentAccordion);
	} else {
		this.closeAccordion(parentAccordion);
	}
};

Accordion.prototype.openAccordion = function (element) {
	if (element.classList) {
		element.classList.add(this.config.active);
	} else {
		element.className += ' ' + this.config.active;
	}
};
Accordion.prototype.closeAccordion = function (element) {
	if (element.classList) {
		element.classList.remove(this.config.active);
	}
	else {
		element.className =
			element.className.replace(new RegExp('(^|\\b)' + this.config.active + '(\\b|$)', 'gi'), ' ');
	}
};

module.exports = Accordion;
